import type { FunctionComponent } from 'preact';
import { GoalpostMcpApp, goalpostMcpAppPost } from './GoalpostMcpApp.tsx';
import { WebMcp, webMcpPost } from './WebMcp.tsx';

// What every post declares about itself. The page's name and summary are i18n
// keys (`blog.<slug>.*`), resolved via useT like the docs pages' labels; the body
// is the post component, inline prose like the docs and legal pages.
export interface BlogPostMeta {
  // URL segment under /blog.
  slug: string;
  titleKey: string;
  summaryKey: string;
  // Publication date as an ISO calendar date (`YYYY-MM-DD`): what the dateline
  // and `<time dateTime>` show.
  publishedOn: string;
}

export interface BlogPost {
  meta: BlogPostMeta;
  component: FunctionComponent;
}

export function blogPostPath(slug: string): string {
  return `/blog/${slug}`;
}

// Every post on the site, newest first. The index lists this order, and the
// router registers one static route per entry, so a post is reachable through
// `Link` and enumerable for the sitemap (docker-entrypoint.sh mirrors the paths
// — update both together when posts change).
export const blogPosts: BlogPost[] = [
  { meta: goalpostMcpAppPost, component: GoalpostMcpApp },
  { meta: webMcpPost, component: WebMcp },
];
